<template>
  <div class="pgs-home-actividades">
    <!-- Header with Dropdown -->
    <v-row class="mb-4">
      <v-col cols="12" md="4">
        <v-select v-model="selectedDepto" :items="actividades" item-text="nm" item-value="id"
          label="Seleccionar Actividad" outlined dense hide-details color="primary" @change="onDeptoChange"
          prepend-inner-icon="mdi-format-list-bulleted" class="rounded-lg" background-color="white"></v-select>
      </v-col>
    </v-row>

    <!-- Contenido Principal -->
    <div v-if="selectedDepto">
      <!-- KPI Cards -->
      <v-row class="mb-6">
        <!-- Jugadores Card -->
        <v-col cols="12" md="4">
          <v-card flat class="pgs-kpi-card pa-5 rounded-xl h-100 d-flex flex-column justify-space-between">
            <div>
              <div class="d-flex align-center justify-space-between mb-3">
                <div class="d-flex align-center">
                  <div class="pgs-kpi-icon-pill pgs-kpi-icon-blue mr-3">
                    <v-icon size="18" color="inherit">mdi-account-group</v-icon>
                  </div>
                  <div>
                    <div class="pgs-kpi-label">Participantes Hoy</div>
                    <div class="text-caption pgs-text-muted line-height-tight">Afluencia y ocupación</div>
                  </div>
                </div>
                <div class="pgs-badge-live">
                  <span class="pgs-badge-dot"></span>
                  <span>En vivo</span>
                </div>
              </div>

              <div class="d-flex align-baseline justify-space-between my-2">
                <div class="d-flex align-baseline">
                  <span v-if="loading.departures" class="text-h4 font-weight-bold pgs-text-primary mr-2">
                    <v-progress-circular indeterminate color="primary" size="28" width="3"></v-progress-circular>
                  </span>
                  <template v-else>
                    <span class="pgs-kpi-metric mr-2">{{ stats.players }}</span>
                    <span class="pgs-kpi-unit">Pax</span>
                  </template>
                </div>
                <div class="text-right">
                  <span class="text-caption font-weight-medium pgs-text-secondary">
                    {{ stats.reservations }} reservaciones
                  </span>
                </div>
              </div>

              <div class="pgs-kpi-progress-bar my-3" title="Distribución de participantes">
                <div class="pgs-progress-segment bg-success" :style="{ width: paidPlayersPercent + '%' }"></div>
                <div class="pgs-progress-segment bg-warning" :style="{ width: pendingPlayersPercent + '%' }"></div>
                <div class="pgs-progress-segment bg-error" :style="{ width: canceledPlayersPercent + '%' }"></div>
              </div>
            </div>

            <div class="pgs-kpi-footer pt-3 border-top-light d-flex align-center justify-space-between text-caption">
              <div class="d-flex align-center">
                <span class="pgs-status-dot bg-success mr-1"></span>
                <span class="font-weight-medium text-slate-700">{{ stats.paid }}</span>
                <span class="pgs-text-muted ml-1">Pagados</span>
              </div>
              <div class="d-flex align-center">
                <span class="pgs-status-dot bg-warning mr-1"></span>
                <span class="font-weight-medium text-slate-700">{{ stats.pending }}</span>
                <span class="pgs-text-muted ml-1">Pend.</span>
              </div>
              <div class="d-flex align-center">
                <span class="pgs-status-dot bg-error mr-1"></span>
                <span class="font-weight-medium text-slate-700">{{ stats.canceled + stats.noShow }}</span>
                <span class="pgs-text-muted ml-1">Canc.</span>
              </div>
            </div>
          </v-card>
        </v-col>

        <!-- Áreas Más Usadas Card -->
        <v-col cols="12" md="4">
          <v-card flat class="pgs-kpi-card pa-5 rounded-xl h-100 d-flex flex-column">
            <div class="d-flex align-center justify-space-between mb-4">
              <div class="d-flex align-center">
                <div class="pgs-kpi-icon-pill pgs-kpi-icon-emerald mr-3">
                  <v-icon size="18" color="inherit">mdi-map-marker-radius</v-icon>
                </div>
                <div>
                  <div class="pgs-kpi-label">Áreas Más Usadas</div>
                  <div class="text-caption pgs-text-muted line-height-tight">Top 3 del día</div>
                </div>
              </div>
            </div>

            <div class="flex-grow-1 d-flex flex-column justify-center mt-2">
              <div v-if="topBahias.length === 0" class="text-center pgs-text-muted text-caption">
                No hay áreas ocupadas hoy
              </div>
              <div v-else>
                <div v-for="(bahia, index) in topBahias" :key="index"
                  class="d-flex align-center justify-space-between mb-2">
                  <div class="d-flex align-center overflow-hidden">
                    <v-avatar size="24" :color="index === 0 ? '#10B981' : (index === 1 ? '#3B82F6' : '#94A3B8')"
                      class="mr-2">
                      <span class="white--text text-caption font-weight-bold">{{ index + 1 }}</span>
                    </v-avatar>
                    <div class="text-body-2 font-weight-medium pgs-text-primary text-truncate">{{ bahia.name }}</div>
                  </div>
                  <div class="text-right">
                    <span class="font-weight-bold pgs-text-primary mr-1">{{ bahia.count }}</span><span
                      class="text-caption pgs-text-muted">res</span>
                    <span class="text-caption pgs-text-secondary ml-2">({{ bahia.pax }} pax)</span>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>

        <!-- Horario Más Concurrido Card -->
        <v-col cols="12" md="4">
          <v-card flat class="pgs-kpi-card pa-5 rounded-xl h-100 d-flex flex-column">
            <div class="d-flex align-center justify-space-between mb-4">
              <div class="d-flex align-center">
                <div class="pgs-kpi-icon-pill pgs-kpi-icon-amber mr-3">
                  <v-icon size="18" color="inherit">mdi-clock-fast</v-icon>
                </div>
                <div>
                  <div class="pgs-kpi-label">Horarios Pico</div>
                  <div class="text-caption pgs-text-muted line-height-tight">Top 3 del día</div>
                </div>
              </div>
            </div>

            <div class="flex-grow-1 d-flex flex-column justify-center mt-2">
              <div v-if="topHorarios.length === 0" class="text-center pgs-text-muted text-caption">
                No hay horarios registrados
              </div>
              <div v-else>
                <div v-for="(horario, index) in topHorarios" :key="index"
                  class="d-flex align-center justify-space-between mb-2">
                  <div class="d-flex align-center overflow-hidden">
                    <v-avatar size="24" :color="index === 0 ? '#F59E0B' : (index === 1 ? '#FBBF24' : '#FDE68A')"
                      class="mr-2">
                      <span :class="index === 2 ? 'black--text' : 'white--text'"
                        class="text-caption font-weight-bold">{{ index
                        + 1 }}</span>
                    </v-avatar>
                    <div class="text-body-2 font-weight-medium pgs-text-primary text-truncate">{{ horario.time }}</div>
                  </div>
                  <div class="text-right">
                    <span class="font-weight-bold pgs-text-primary mr-1">{{ horario.pax }}</span><span
                      class="text-caption pgs-text-muted">pax</span>
                    <span class="text-caption pgs-text-secondary ml-2">({{ horario.count }} res)</span>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>

        <!-- Ingresos MXN Card -->
        <v-col v-if="false" cols="12" md="4">
          <v-card flat class="pgs-kpi-card pa-5 rounded-xl h-100 d-flex flex-column justify-space-between">
            <div>
              <div class="d-flex align-center justify-space-between mb-3">
                <div class="d-flex align-center">
                  <div class="pgs-kpi-icon-pill pgs-kpi-icon-emerald mr-3">
                    <v-icon size="18" color="inherit">mdi-cash-multiple</v-icon>
                  </div>
                  <div>
                    <div class="pgs-kpi-label">Ingresos (MXN)</div>
                    <div class="text-caption pgs-text-muted line-height-tight">Total proyectado hoy</div>
                  </div>
                </div>
                <div class="pgs-badge-currency">
                  <span>MXN</span>
                </div>
              </div>

              <div class="d-flex align-baseline justify-space-between my-2">
                <div class="d-flex align-baseline">
                  <span v-if="loading.departures" class="text-h4 font-weight-bold pgs-text-primary mr-2">
                    <v-progress-circular indeterminate color="success" size="28" width="3"></v-progress-circular>
                  </span>
                  <template v-else>
                    <span class="pgs-kpi-metric mr-1">${{ formatNumber(stats.revenueMXN) }}</span>
                  </template>
                </div>
                <div class="text-right">
                  <span class="text-caption font-weight-medium pgs-text-secondary" v-if="stats.avgTicketMXN > 0">
                    Prom: ${{ formatNumber(stats.avgTicketMXN) }}/pax
                  </span>
                  <span class="text-caption font-weight-medium pgs-text-muted" v-else>
                    Sin cobros
                  </span>
                </div>
              </div>

              <div class="pgs-kpi-progress-bar my-3" title="% Cobrado en MXN">
                <div class="pgs-progress-segment bg-emerald" :style="{ width: paidRevenuePercentMXN + '%' }"></div>
                <div class="pgs-progress-segment bg-amber-soft" :style="{ width: (100 - paidRevenuePercentMXN) + '%' }">
                </div>
              </div>
            </div>

            <div class="pgs-kpi-footer pt-3 border-top-light d-flex align-center justify-space-between text-caption">
              <div class="d-flex align-center">
                <v-icon size="14" color="success" class="mr-1">mdi-check-circle-outline</v-icon>
                <span class="pgs-text-muted mr-1">Cobrado:</span>
                <span class="font-weight-semibold text-emerald">${{ formatNumber(stats.paidRevenueMXN) }}</span>
                <span class="pgs-text-muted ml-1" v-if="stats.revenueMXN > 0">({{ paidRevenuePercentMXN }}%)</span>
              </div>
              <div class="d-flex align-center">
                <v-icon size="14" color="warning" class="mr-1">mdi-clock-outline</v-icon>
                <span class="pgs-text-muted mr-1">Pendiente:</span>
                <span class="font-weight-medium pgs-text-secondary">${{ formatNumber(stats.pendingRevenueMXN) }}</span>
              </div>
            </div>
          </v-card>
        </v-col>

        <!-- Ingresos USD Card -->
        <v-col v-if="false" cols="12" md="4">
          <v-card flat class="pgs-kpi-card pa-5 rounded-xl h-100 d-flex flex-column justify-space-between">
            <div>
              <div class="d-flex align-center justify-space-between mb-3">
                <div class="d-flex align-center">
                  <div class="pgs-kpi-icon-pill pgs-kpi-icon-amber mr-3">
                    <v-icon size="18" color="inherit">mdi-currency-usd</v-icon>
                  </div>
                  <div>
                    <div class="pgs-kpi-label">Ingresos (USD)</div>
                    <div class="text-caption pgs-text-muted line-height-tight">Moneda extranjera</div>
                  </div>
                </div>
                <div class="pgs-badge-currency">
                  <span>USD</span>
                </div>
              </div>

              <div class="d-flex align-baseline justify-space-between my-2">
                <div class="d-flex align-baseline">
                  <span v-if="loading.departures" class="text-h4 font-weight-bold pgs-text-primary mr-2">
                    <v-progress-circular indeterminate color="warning" size="28" width="3"></v-progress-circular>
                  </span>
                  <template v-else>
                    <span class="pgs-kpi-metric mr-1">${{ formatNumber(stats.revenueUSD) }}</span>
                  </template>
                </div>
                <div class="text-right">
                  <span class="text-caption font-weight-medium pgs-text-secondary" v-if="stats.avgTicketUSD > 0">
                    Prom: ${{ formatNumber(stats.avgTicketUSD) }}/pax
                  </span>
                  <span class="text-caption font-weight-medium pgs-text-muted" v-else>
                    Sin cobros
                  </span>
                </div>
              </div>

              <div class="pgs-kpi-progress-bar my-3" title="% Cobrado en USD">
                <div class="pgs-progress-segment bg-amber" :style="{ width: paidRevenuePercentUSD + '%' }"></div>
                <div class="pgs-progress-segment bg-slate-soft" :style="{ width: (100 - paidRevenuePercentUSD) + '%' }">
                </div>
              </div>
            </div>

            <div class="pgs-kpi-footer pt-3 border-top-light d-flex align-center justify-space-between text-caption">
              <div class="d-flex align-center">
                <v-icon size="14" color="warning" class="mr-1">mdi-check-circle-outline</v-icon>
                <span class="pgs-text-muted mr-1">Cobrado:</span>
                <span class="font-weight-semibold text-amber">${{ formatNumber(stats.paidRevenueUSD) }}</span>
                <span class="pgs-text-muted ml-1" v-if="stats.revenueUSD > 0">({{ paidRevenuePercentUSD }}%)</span>
              </div>
              <div class="d-flex align-center">
                <v-icon size="14" color="grey" class="mr-1">mdi-clock-outline</v-icon>
                <span class="pgs-text-muted mr-1">Pendiente:</span>
                <span class="font-weight-medium pgs-text-secondary">${{ formatNumber(stats.pendingRevenueUSD) }}</span>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Gráfica de Afluencia por Bahía y Hora -->
      <v-row class="mb-6">
        <v-col cols="12">
          <v-card flat class="pgs-dashboard-panel rounded-xl h-100 pa-4">
            <div v-if="loading.departures" class="d-flex justify-center align-center h-100 min-h-300">
              <v-progress-circular indeterminate color="primary" size="48" width="4"></v-progress-circular>
            </div>
            <fusioncharts v-else type="mscolumn2d" width="100%" height="350" dataFormat="json"
              :dataSource="chartDataBahiasTime">
            </fusioncharts>
          </v-card>
        </v-col>
      </v-row>

      <!-- Tabla Próximas Actividades -->
      <v-row>
        <v-col cols="12">
          <v-card flat class="pgs-dashboard-panel rounded-xl h-100">
            <div class="pa-5 d-flex align-center justify-space-between border-bottom-light">
              <div class="d-flex align-center">
                <v-icon color="primary" class="mr-3">mdi-calendar-check</v-icon>
                <div>
                  <h2 class="text-h6 font-weight-bold pgs-text-primary mb-0">Próximas Reservas</h2>
                  <span class="text-caption pgs-text-secondary">Reservaciones programadas para el día de hoy</span>
                </div>
              </div>
            </div>

            <v-data-table :headers="departuresHeaders" :items="nextDepartures" :loading="loading.departures"
              :items-per-page="5" class="pgs-custom-table" no-data-text="No hay reservaciones para esta actividad hoy.">

              <template v-slot:item.bahia="{ item }">
                <div class="font-weight-medium pgs-text-primary">{{ item.bahia }}</div>
              </template>

              <template v-slot:item.time="{ item }">
                <div class="d-flex align-center">
                  <v-icon size="16" color="primary" class="mr-1">mdi-clock-outline</v-icon>
                  <span class="font-weight-bold" style="color: #0F172A;">{{ item.time }} - {{ item.timeEnd }}</span>
                </div>
              </template>

              <template v-slot:item.client="{ item }">
                <div class="d-flex align-center py-2">
                  <v-avatar size="32" color="#EFF6FF" class="mr-3">
                    <span class="font-weight-bold" style="color: #3B82F6; font-size: 12px;">
                      {{ item.client ? item.client.charAt(0).toUpperCase() : 'U' }}
                    </span>
                  </v-avatar>
                  <div>
                    <div class="font-weight-medium text-body-2" style="color: #0F172A;">{{ item.client }}</div>
                    <div v-if="item.folio" class="text-caption pgs-text-secondary">Folio: {{ item.folio }}</div>
                  </div>
                </div>
              </template>

              <template v-slot:item.tarifa="{ item }">
                <v-chip v-if="item.tarifa" x-small color="#F1F5F9" text-color="#475569"
                  class="font-weight-medium px-2 rounded-md">
                  {{ item.tarifa }}
                </v-chip>
                <span v-else class="text-caption text-muted">--</span>
              </template>

              <template v-slot:item.pax="{ item }">
                <v-chip small color="#F1F5F9" text-color="#475569" class="font-weight-medium px-3 rounded-lg">
                  <v-icon left size="14">mdi-account-group</v-icon> {{ item.pax }} Pax
                </v-chip>
              </template>

              <template v-slot:item.status="{ item }">
                <v-chip small :color="getStatusColor(item.status)" text-color="white"
                  class="font-weight-medium px-3 rounded-lg">
                  {{ item.status }}
                </v-chip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- Empty State -->
    <v-row v-else>
      <v-col cols="12">
        <v-card flat class="pgs-dashboard-panel rounded-xl pa-10 text-center">
          <v-icon size="48" color="#94A3B8" class="mb-4">mdi-gesture-tap</v-icon>
          <h3 class="text-h6 font-weight-bold pgs-text-primary mb-2">Seleccione una Actividad</h3>
          <p class="text-body-2 pgs-text-secondary mb-0">Use el menú desplegable superior para cargar los indicadores en
            tiempo real de alguna de sus actividades.</p>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import ActivityReservation from "../../clases/ActivityReservation.js";

export default {
  name: "HomeActividades",
  data() {
    return {
      selectedDepto: null,
      actualListener: null,
      unsubscribeReservas: null,
      bahias: [],
      actividades: [],
      topBahias: [],
      topHorarios: [],
      loading: {
        departures: false
      },
      stats: {
        reservations: 0,
        players: 0,
        totalRegistered: 0,
        paid: 0,
        pending: 0,
        canceled: 0,
        noShow: 0,
        revenueMXN: 0,
        paidRevenueMXN: 0,
        pendingRevenueMXN: 0,
        avgTicketMXN: 0,
        revenueUSD: 0,
        paidRevenueUSD: 0,
        pendingRevenueUSD: 0,
        avgTicketUSD: 0
      },
      chartDataBahiasTime: {
        chart: {
          caption: "Afluencia por Área y Horario",
          subCaption: "Cantidad de participantes activos",
          xAxisName: "Hora",
          yAxisName: "Pax",
          theme: "fusion",
          palettecolors: "#3B82F6,#10B981,#F59E0B,#EF4444,#8B5CF6,#EC4899,#14B8A6",
          bgColor: "#ffffff",
          showBorder: "0",
          showCanvasBorder: "0",
          legendPosition: "bottom",
          drawCrossLine: "1"
        },
        categories: [{ category: [] }],
        dataset: []
      },
      nextDepartures: [],
      departuresHeaders: [
        { text: 'Espacio/Bahía', value: 'bahia', sortable: true },
        { text: 'Horario', value: 'time', sortable: true, width: '135px' },
        { text: 'Cliente', value: 'client', sortable: true },
        { text: 'Tarifa', value: 'tarifa', sortable: false },
        { text: 'Pax', value: 'pax', sortable: false, align: 'center' },
        { text: 'Estatus', value: 'status', sortable: false, align: 'end' }
      ]
    };
  },
  computed: {
    ...mapGetters(["getFirebaseApp", "getDepartamentos"]),

    paidPlayersPercent() {
      const total = this.stats.totalRegistered || this.stats.players;
      if (!total || total === 0) return 0;
      return Math.min(100, Math.round((this.stats.paid / total) * 100));
    },
    pendingPlayersPercent() {
      const total = this.stats.totalRegistered || this.stats.players;
      if (!total || total === 0) return 0;
      return Math.min(100, Math.round((this.stats.pending / total) * 100));
    },
    canceledPlayersPercent() {
      const total = this.stats.totalRegistered || this.stats.players;
      if (!total || total === 0) return 0;
      return Math.min(100, Math.round(((this.stats.canceled + this.stats.noShow) / total) * 100));
    },
    paidRevenuePercentMXN() {
      if (!this.stats.revenueMXN || this.stats.revenueMXN === 0) return 0;
      return Math.min(100, Math.round((this.stats.paidRevenueMXN / this.stats.revenueMXN) * 100));
    },
    paidRevenuePercentUSD() {
      if (!this.stats.revenueUSD || this.stats.revenueUSD === 0) return 0;
      return Math.min(100, Math.round((this.stats.paidRevenueUSD / this.stats.revenueUSD) * 100));
    }
  },
  methods: {
    async getActividades() {
      let actividades = [];
      const snapshot = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "ACT/Actividades"
      );
      if (snapshot.val()) {
        let docs = Object.entries(snapshot.val());
        docs.forEach((element) => {
          actividades.push({ id: element[0], ...element[1] });
        });
        this.actividades = actividades;
        if (this.actividades.length > 0 && !this.selectedDepto) {
          this.selectedDepto = this.actividades[0].id;
          this.onDeptoChange();
        }
      } else {
        this.actividades = []
      }
    },
    formatNumber(num) {
      if (!num) return "0.00";
      return Number(num).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    getStatusColor(status) {
      const s = status ? status.toLowerCase() : '';
      if (s.includes('confirm') || s.includes('pagad')) return '#10B981';
      if (s.includes('pend') || s.includes('reserv')) return '#F59E0B';
      if (s.includes('cancel')) return '#EF4444';
      if (s.includes('checkin') || s.includes('llegó')) return '#3B82F6';
      return '#64748B';
    },
    async getBahias() {
      let bahias = [];
      const snapshot = await this.getFirebaseApp.database.queryBuilder("ACT/Bahias");
      if (snapshot.val()) {
        let docs = Object.entries(snapshot.val());
        docs.forEach((element) => {
          if (element[1].ia == this.selectedDepto) {
            bahias.push({ id: element[0], ...element[1] });
          }
        });
      }
      bahias.sort((a, b) => (a.od || 0) - (b.od || 0));
      this.bahias = bahias;
    },
    async onDeptoChange() {
      if (this.selectedDepto) {
        this.loading.departures = true;
        await this.getBahias();
        this.fetchReservasRTDB();
      }
    },
    killListener(date) {
      if (typeof this.unsubscribeReservas === "function") {
        try {
          this.unsubscribeReservas();
        } catch (e) {
          console.warn("Error calling unsubscribe function:", e);
        }
        this.unsubscribeReservas = null;
      }
      if (date && this.getFirebaseApp && this.getFirebaseApp.database) {
        try {
          const path = "ACT/Availability/" + this.selectedDepto + "/" + date;
          const ref = this.getFirebaseApp.database.ref(path);
          this.getFirebaseApp.database.off(ref);
        } catch (e) {
          console.warn("Error calling database.off:", e);
        }
      }
    },
    fetchReservasRTDB() {
      const date = moment().format("YYYY-MM-DD");

      if (this.actualListener) {
        this.killListener(this.actualListener);
      }

      this.loading.departures = true;

      this.unsubscribeReservas = this.getFirebaseApp.database.queryBuilderListener(
        "ACT/Availability/" + this.selectedDepto + "/" + date,
        null,
        (snapshot) => {
          try {

            if (snapshot.exists()) {
              let arrayReservas = snapshot.val();
              let reservaList = ActivityReservation.parseAvailability(arrayReservas);

              let totalPlayers = 0;
              let totalRegistered = 0;
              let totalReservas = 0;
              let totalPagados = 0;
              let totalPendientes = 0;
              let totalCancelados = 0;
              let totalNoShow = 0;
              let revMXN = 0;
              let paidRevMXN = 0;
              let pendingRevMXN = 0;
              let revUSD = 0;
              let paidRevUSD = 0;
              let pendingRevUSD = 0;

              let departures = [];
              let bahiaUsage = {};
              let horarioUsage = {};
              
              let chartDataObj = {};
              let allBahiasSet = new Set();

              reservaList.forEach((element) => {
                totalReservas++;

                let bahiaObj = this.bahias.find(b => b.id === element.bahia);
                let bahiaName = bahiaObj ? bahiaObj.nm : "Mesa/Bahía";

                let tStart = element.HoraInicial || "--:--";
                let tEnd = element.HoraFinal || "--:--";
                let statusE = element.et || "R";

                let pax = 1;
                if (element.pv && element.pv.length > 0) {
                  pax = element.pv.length;
                } else if (element.cl && element.cl.gp) {
                  pax = parseInt(element.cl.gp) || 1;
                }

                if (statusE == "P") totalPagados++;
                else if (statusE == "R") totalPendientes++;
                else if (statusE == "C") totalCancelados++;
                else if (statusE == "N") totalNoShow++;

                if (statusE !== "C" && statusE !== "N") {
                  totalPlayers += pax;
                  if (!bahiaUsage[bahiaName]) {
                    bahiaUsage[bahiaName] = { name: bahiaName, count: 0, pax: 0 };
                  }
                  bahiaUsage[bahiaName].count++;
                  bahiaUsage[bahiaName].pax += pax;

                  const validTime = tStart !== "--:--" ? tStart : "Sin hora";
                  if (!horarioUsage[validTime]) {
                    horarioUsage[validTime] = { time: validTime, count: 0, pax: 0 };
                  }
                  horarioUsage[validTime].count++;
                  horarioUsage[validTime].pax += pax;

                  // Lógica para gráfica Multi-Series
                  if (!chartDataObj[validTime]) {
                    chartDataObj[validTime] = {};
                  }
                  if (!chartDataObj[validTime][bahiaName]) {
                    chartDataObj[validTime][bahiaName] = 0;
                  }
                  chartDataObj[validTime][bahiaName] += pax;
                  allBahiasSet.add(bahiaName);
                }
                totalRegistered += pax;

                if (element.tt && statusE !== "C" && statusE !== "N") {
                  const amount = Number(element.tt.C) || 0;
                  const currency = element.tt.M ? String(element.tt.M).toUpperCase() : "MXN";
                  if (currency === "MXN") {
                    revMXN += amount;
                    if (statusE === "P") paidRevMXN += amount;
                    else if (statusE === "R") pendingRevMXN += amount;
                  } else if (currency === "USD") {
                    revUSD += amount;
                    if (statusE === "P") paidRevUSD += amount;
                    else if (statusE === "R") pendingRevUSD += amount;
                  }
                }

                let statusText = 'Confirmada';
                if (statusE === 'P') statusText = 'Pagada';
                else if (statusE === 'R') statusText = 'Pendiente';
                else if (statusE === 'C') statusText = 'Cancelada';
                else if (statusE === 'N') statusText = 'No Show';

                departures.push({
                  id: element.idReserva,
                  bahia: bahiaName,
                  time: tStart,
                  timeEnd: tEnd,
                  client: (element.py) ? element.py.nm : 'Sin nombre',
                  tarifa: element.nt || '',
                  folio: element.fl || '',
                  status: statusText,
                  pax: pax
                });
              });

              this.stats.players = totalPlayers;
              this.stats.totalRegistered = totalRegistered;
              this.stats.reservations = totalReservas;
              this.stats.paid = totalPagados;
              this.stats.pending = totalPendientes;
              this.stats.canceled = totalCancelados;
              this.stats.noShow = totalNoShow;
              this.stats.revenueMXN = revMXN;
              this.stats.paidRevenueMXN = paidRevMXN;
              this.stats.pendingRevenueMXN = pendingRevMXN;
              this.stats.revenueUSD = revUSD;
              this.stats.paidRevenueUSD = paidRevUSD;
              this.stats.pendingRevenueUSD = pendingRevUSD;

              // Promedios
              this.stats.avgTicketMXN = totalPlayers > 0 ? (revMXN / totalPlayers) : 0;
              this.stats.avgTicketUSD = totalPlayers > 0 ? (revUSD / totalPlayers) : 0;

              this.topBahias = Object.values(bahiaUsage).sort((a, b) => b.count - a.count).slice(0, 3);
              this.topHorarios = Object.values(horarioUsage).sort((a, b) => b.pax - a.pax).slice(0, 3);

              // Construir la data para la gráfica
              let sortedTimes = Object.keys(chartDataObj).sort();
              let categories = sortedTimes.map(t => ({ label: t }));
              let datasetsMap = {};
              
              allBahiasSet.forEach(b => {
                datasetsMap[b] = { seriesname: b, data: [] };
              });
              
              sortedTimes.forEach(t => {
                allBahiasSet.forEach(b => {
                  let val = chartDataObj[t][b] || 0;
                  datasetsMap[b].data.push({ value: val });
                });
              });
              
              this.chartDataBahiasTime.categories = [{ category: categories }];
              this.chartDataBahiasTime.dataset = Object.values(datasetsMap);

              // Ordenar y filtrar próximas salidas
              departures.sort((a, b) => moment(a.time, "HH:mm").diff(moment(b.time, "HH:mm")));
              const now = moment();
              const upcoming = departures.filter(d => d.time !== '--:--' && moment(d.time, "HH:mm").isSameOrAfter(now, 'minute'));

              // Si hay salidas próximas después de la hora actual, mostrar esas; de lo contrario mostrar las del día
              this.nextDepartures = upcoming.length > 0 ? upcoming : departures;

            } else {
              // Limpiar data
              this.stats.players = 0;
              this.stats.totalRegistered = 0;
              this.stats.reservations = 0;
              this.stats.paid = 0;
              this.stats.pending = 0;
              this.stats.canceled = 0;
              this.stats.noShow = 0;
              this.stats.revenueMXN = 0;
              this.stats.paidRevenueMXN = 0;
              this.stats.pendingRevenueMXN = 0;
              this.stats.revenueUSD = 0;
              this.stats.paidRevenueUSD = 0;
              this.stats.pendingRevenueUSD = 0;
              this.stats.avgTicketMXN = 0;
              this.stats.avgTicketUSD = 0;
              this.nextDepartures = [];
              this.topBahias = [];
              this.topHorarios = [];
              this.chartDataBahiasTime.categories = [{ category: [] }];
              this.chartDataBahiasTime.dataset = [];
            }
          } catch (e) {
            console.error("Error parsing Actividades stats", e);
          } finally {
            this.loading.departures = false;
          }
        }
      );
      this.actualListener = date;
    }
  },
  beforeDestroy() {
    if (this.actualListener) {
      this.killListener(this.actualListener);
    }
  },
  mounted() {
    this.getActividades();
  }
};
</script>

<style scoped>
.pgs-dashboard {
  font-family: 'Inter', -apple-system, sans-serif;
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px;
}

.pgs-text-primary {
  color: #0F172A;
}

.pgs-text-secondary {
  color: #64748B;
}

.letter-spacing-wide {
  letter-spacing: 0.5px;
}

.line-height-tight {
  line-height: 1.2;
}

.cursor-pointer {
  cursor: pointer;
}

.border-bottom-light {
  border-bottom: 1px solid #F1F5F9;
}

.pgs-weather-pill {
  background-color: #FFFFFF;
  border: 1px solid #E2E8F0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.pgs-kpi-card {
  background: #FFFFFF !important;
  border: 1px solid #E2E8F0 !important;
  border-radius: 16px !important;
  box-shadow: 0 1px 3px 0 rgba(15, 23, 42, 0.04), 0 1px 2px -1px rgba(15, 23, 42, 0.04) !important;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.2s ease;
}

.pgs-kpi-card:hover {
  transform: translateY(-2px);
  border-color: #CBD5E1 !important;
  box-shadow: 0 10px 20px -5px rgba(15, 23, 42, 0.08), 0 4px 6px -2px rgba(15, 23, 42, 0.04) !important;
}

.pgs-kpi-label {
  font-size: 0.8125rem;
  font-weight: 700;
  color: #1E293B;
  letter-spacing: 0.2px;
}

.pgs-kpi-metric {
  font-size: 1.85rem;
  font-weight: 800;
  color: #0F172A;
  letter-spacing: -0.03em;
  line-height: 1.1;
}

.pgs-kpi-unit {
  font-size: 0.875rem;
  font-weight: 600;
  color: #64748B;
}

.pgs-kpi-icon-pill {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.pgs-kpi-icon-blue {
  background-color: #EFF6FF;
  color: #2563EB;
}

.pgs-kpi-icon-emerald {
  background-color: #ECFDF5;
  color: #059669;
}

.pgs-kpi-icon-amber {
  background-color: #FFFBEB;
  color: #D97706;
}

.pgs-badge-live {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 8px;
  border-radius: 9999px;
  background: #F0FDF4;
  border: 1px solid #DCFCE7;
  color: #16A34A;
  font-size: 11px;
  font-weight: 600;
}

.pgs-badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #22C55E;
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.2);
  animation: pgsPulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pgsPulse {

  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.4;
    transform: scale(1.15);
  }
}

.pgs-badge-currency {
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border-radius: 9999px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.pgs-kpi-progress-bar {
  width: 100%;
  height: 5px;
  background-color: #F1F5F9;
  border-radius: 9999px;
  display: flex;
  overflow: hidden;
}

.pgs-progress-segment {
  height: 100%;
  transition: width 0.4s ease;
}

.bg-emerald {
  background-color: #10B981 !important;
}

.bg-amber {
  background-color: #F59E0B !important;
}

.bg-amber-soft {
  background-color: #FEF3C7 !important;
}

.bg-slate-soft {
  background-color: #E2E8F0 !important;
}

.bg-success {
  background-color: #10B981 !important;
}

.bg-warning {
  background-color: #F59E0B !important;
}

.bg-error {
  background-color: #EF4444 !important;
}

.pgs-status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}

.pgs-text-muted {
  color: #94A3B8;
}

.text-slate-700 {
  color: #334155;
}

.text-emerald {
  color: #059669;
}

.text-amber {
  color: #D97706;
}

.border-top-light {
  border-top: 1px solid #F1F5F9;
}

.pgs-dashboard-panel {
  border: 1px solid #E2E8F0 !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.03), 0 2px 4px -2px rgba(0, 0, 0, 0.03) !important;
  overflow: hidden;
}

.pgs-action-card {
  border: 1px solid #F1F5F9 !important;
  background-color: #F8FAFC !important;
  transition: all 0.2s ease;
}

.pgs-action-card:hover {
  background-color: #FFFFFF !important;
  border-color: #E2E8F0 !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
  transform: translateY(-2px);
}

.min-h-300 {
  min-height: 300px;
}

.pgs-custom-table {
  background: transparent !important;
}

.pgs-custom-table>>>.v-data-table-header th {
  background-color: #F8FAFC !important;
  color: #64748B !important;
  font-weight: 600 !important;
  text-transform: uppercase;
  font-size: 11px !important;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #E2E8F0 !important;
}

.pgs-custom-table>>>tbody tr {
  transition: background-color 0.15s ease;
}

.pgs-custom-table>>>tbody tr:hover {
  background-color: #F8FAFC !important;
}

.pgs-custom-table>>>tbody td {
  border-bottom: 1px solid #F1F5F9 !important;
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}
</style>
